export const enum TYPE_EVENT_SSE {
  DATA = "data-event",
}
